import { findFirstValueDefined, selectNonEmptyValues } from '@dirootie-toolbox/objects';
import { flatten } from 'ramda';

export const getProtected = (obj:any) => {
  const result = findFirstValueDefined<boolean>(["route.protected","protected","section.protected"],obj, true) as boolean;
  return result === false ? false : true;
}

export const getRoles = (obj:any) => {
  const roles = selectNonEmptyValues(["route.roles","roles","section.roles"],obj);
  return roles ? flatten(roles) : [];
}
